module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Add by group</h1>\n<p>\n    You can add all of the names contained within a group to your\n    name selection.\n</p>\n<br/>\n<div class="filter-hook"></div>\n<div class="grid-container">\n    <div class="grid-60">\n        <div class="main-hook"></div>\n    </div>\n</div>\n\n<div class="pagination-hook"></div>\n\n<button class="pull-right button button-secondary close-button">\n    Close\n</button>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/groups_layout.html
// module id = 263
// module chunks = 0